import colors from '../colors';
// import { shadow, background } from '../elevation';

const lightOverrides = {
  MuiButton: {
    styleOverrides: {
      root: {
        textTransform: 'none',
      },
    },
    variants: [
      {
        props: { variant: 'text' },
        style: {
          padding: '10px 24px',

          '&:hover': {
            background: colors.surface.light[1],
          },
          '&:focus': {
            background: colors.surface.light[2],
          },
          '&:active': {
            background: colors.surface.light[3],
          },
          '&:disabled': {
            color: colors.neutral[10],
            opacity: 0.38,
          },
        },
      },
      {
        props: { variant: 'outlined' },
        style: {
          color: colors.neutral[40],
          border: `1px solid ${colors.neutral[40]}`,
        },
      },
    ],
  },
  MuiInputLabel: {
    styleOverrides: {
      shrink: {
        color: colors.neutral[10],
        fontWeight: 600,
        '&.Mui-focused': {
          color: colors.darkBlue[50],
        },
        '&.Mui-error': {
          color: colors.red[50],
        },
        '&.Mui-disabled': {
          color: colors.neutral[80],
        },
      },
    },
  },
  MuiOutlinedInput: {
    styleOverrides: {
      root: {
        '&.Mui-focused': {
          '.MuiOutlinedInput-notchedOutline': {
            border: `2px solid ${colors.darkBlue[50]}`,
          },
        },
        '&.Mui-error': {
          '.MuiOutlinedInput-notchedOutline': {
            border: `2px solid ${colors.red[50]}`,
          },
        },
        '&.Mui-disabled': {
          '.MuiOutlinedInput-notchedOutline': {
            borderColor: colors.neutral[90],
          },
        },
      },
      notchedOutline: {
        border: `1px solid ${colors.neutral[70]}`,
        borderRadius: '4px',
      },
    },
  },
};

export default lightOverrides;
